goog.provide("shadow.js.shim.module$$mui$material$Badge$default");
shadow.js.shim.module$$mui$material$Badge$default = shadow.js.shim.module$$mui$material$Badge.default;
